function errorLoading(err) {
  console.error('Dynamic page loading failed', err);
}

function loadRoute(cb) {
  return (module) => cb(null, module.default);
}

export default [
  {
    path: 'profile/',
    getComponent: (nextState, cb) => {
      import(/* webpackChunkName: "profile" */ 'components/Profile')
        .then(loadRoute(cb)).catch(errorLoading);
    }
  },
  {
    path: 'profile/companies/',
    getComponent: (nextState, cb) => {
      import(/* webpackChunkName: "profile" */ 'components/Profile/Companies')
        .then(loadRoute(cb)).catch(errorLoading);
    }
  },
  {
    path: 'profile/companies/create/',
    getComponent: (nextState, cb) => {
      import(/* webpackChunkName: "profile" */ 'components/Profile/CreateCompany')
        .then(loadRoute(cb)).catch(errorLoading);
    }
  },
  {
    path: 'profile/companies/:companyId/:page/',
    getComponent: (nextState, cb) => {
      import(/* webpackChunkName: "profile" */ 'components/Profile/Company')
        .then(loadRoute(cb)).catch(errorLoading);
    }
  },
  {
    path: 'profile/bookings/',
    getComponent: (nextState, cb) => {
      import(/* webpackChunkName: "profile" */ 'components/Profile/Bookings')
        .then(loadRoute(cb)).catch(errorLoading);
    }
  }
];



// WEBPACK FOOTER //
// ./src/profileRoutes.js